import {
  absoluteImage,
  absoluteUrl,
  DEFAULT_SEO_PUBLISHER,
  stripHtml,
} from "../config/seo";

const truncate = (s: string, maxLen: number) => {
  const text = s.trim();
  if (!text) return "";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}...`;
};

export const buildBookDescription = (book: any) => {
  const html = book?.description ?? book?.intro ?? "";
  const text = stripHtml(html);
  return truncate(text, 160);
};

export const buildBookKeywords = (book: any) => {
  const parts = [book?.author, book?.bookLanguage, book?.name]
    .map((v: any) => (v ? String(v).trim() : ""))
    .filter(Boolean);

  const uniq: string[] = [];
  for (const p of parts) {
    const key = p.toLowerCase();
    if (!uniq.some((x) => x.toLowerCase() === key)) uniq.push(p);
  }

  return uniq.join(", ");
};

export const buildBookJsonLd = (book: any, canonicalPath: string) => {
  const url = absoluteUrl(canonicalPath);
  const seoImage = book?.ogImage || book?.bookPath || "";
  const image = seoImage ? absoluteImage(seoImage) : "";
  const description = buildBookDescription(book);
  const authorName = book?.author ? String(book.author).trim() : "";
  const name = book?.name ? String(book.name).trim() : "";
  const inLanguage = book?.bookLanguage ? String(book.bookLanguage).trim() : "";

  const jsonLd: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "Book",
    name: name || undefined,
    url: url || undefined,
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    ...(authorName ? { author: { "@type": "Person", name: authorName } } : {}),
    ...(inLanguage ? { inLanguage } : {}),
    publisher: { "@type": "Organization", name: DEFAULT_SEO_PUBLISHER },
  };

  // Remove undefined properties so schema is cleaner.
  for (const key of Object.keys(jsonLd)) {
    if (jsonLd[key] === undefined) delete jsonLd[key];
  }

  return jsonLd;
};

